function init () {
    const mobileMenuToggle = document.querySelector('.region-we-mega-menu .navbar-toggle');
    const mobileMenu = document.querySelector('.navbar-we-mega-menu');

    // add class to menu toggle to do animation
    if (mobileMenuToggle && mobileMenu) {
        mobileMenuToggle.addEventListener('click', () => {
            mobileMenuToggle.classList.toggle('menu-opened');
        })
    }
}



export { init };
